<template>
  <section class="hero funnel">
    <form @submit.prevent="onSubmit">
      <div v-if="currentStepIndex < 5" class="hero-header">
        <div class="container">
          <div class="columns is-mobile funnel-progress">
            <div
              class="column has-text-centered"
              v-for="(step, index) of steps.slice(0, 5)"
              :key="index"
            >
              <span
                class="rounded is-size-3"
                :class="{
                  'candidblue bluetext': currentStepIndex !== index,
                  'superblue has-text-white': currentStepIndex === index
                }"
                style="font-weight: 900; pointer-events: none"
                >{{ index + 1 }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="hero-body">
        <div class="bubble-container">
          <div class="bubble-message">
            <span class="icon">
              <svg
                width="25"
                height="26"
                viewBox="0 0 25 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_3_2072)">
                  <path
                    d="M12.4512 23.5154C14.1758 23.4067 15.7171 22.9004 17.1162 21.9645C17.4564 21.7362 17.8058 21.653 18.1832 21.845C18.8701 22.1941 18.9192 23.118 18.2682 23.5651C17.0099 24.4299 15.6268 25.0019 14.1347 25.2933C9.51483 26.197 4.84982 24.1412 2.35721 20.1061C-1.44149 13.9588 1.3793 5.74364 8.12768 3.31051C8.40405 3.21115 8.6844 3.11984 8.98468 3.01779C8.98468 2.35042 8.98468 1.68037 8.98468 1.01032C8.98468 0.612855 9.08301 0.506775 9.47231 0.505432C11.1425 0.502747 12.8113 0.502747 14.4814 0.505432C14.8495 0.505432 14.9571 0.618226 14.9584 0.991521C14.9611 1.57832 14.9691 2.16646 14.9531 2.75326C14.9465 2.97079 15.0196 3.04598 15.2229 3.11178C18.9405 4.32432 21.4464 6.79639 22.7379 10.524C22.8774 10.9281 22.8402 11.3001 22.5412 11.6143C22.2782 11.8909 21.9486 11.9849 21.5793 11.8815C21.2099 11.7781 20.9973 11.5203 20.8817 11.1551C20.5017 9.96133 19.9038 8.88845 19.0999 7.93238C19.0468 7.86927 18.987 7.81019 18.9113 7.72828C18.5618 8.0868 18.2257 8.44264 17.8762 8.7864C17.6344 9.02407 17.3381 9.01736 17.1441 8.79177C16.9648 8.58229 16.982 8.32179 17.2052 8.09083C17.5401 7.74439 17.8842 7.40736 18.223 7.06897C17.2491 5.85375 14.4163 4.64927 12.4552 4.62644C12.4552 4.79832 12.4552 4.9702 12.4552 5.14207C12.4552 5.47777 12.4632 5.81347 12.4525 6.14916C12.4419 6.45398 12.24 6.64331 11.9596 6.6366C11.6939 6.62988 11.5039 6.44323 11.4959 6.14782C11.4853 5.74767 11.4932 5.34618 11.4919 4.94603C11.4919 4.84532 11.4919 4.74595 11.4919 4.6157C9.27699 4.76072 7.37166 5.55699 5.69221 7.05152C6.0576 7.41407 6.42564 7.74842 6.7525 8.11903C6.85613 8.23585 6.91327 8.46816 6.87474 8.61586C6.83886 8.75014 6.65285 8.91665 6.51732 8.9341C6.36452 8.9529 6.1599 8.85622 6.03767 8.74343C5.69088 8.42653 5.37332 8.07472 5.0292 7.72291C3.55967 9.40274 2.76911 11.3296 2.62162 13.5815C2.99631 13.5815 3.3524 13.5815 3.70848 13.5815C3.83737 13.5815 3.96625 13.5788 4.09646 13.5815C4.42464 13.5922 4.62129 13.7735 4.62262 14.0649C4.62262 14.3549 4.43129 14.5456 4.10045 14.555C3.7324 14.5658 3.36303 14.5577 2.99365 14.559C2.8847 14.559 2.77442 14.559 2.62561 14.559C2.76379 16.7988 3.561 18.7257 5.0292 20.4122C5.38661 20.0457 5.72277 19.6898 6.07221 19.3461C6.31403 19.1084 6.61033 19.1151 6.80432 19.3407C6.98369 19.5502 6.96774 19.8107 6.74452 20.0416C6.4097 20.3881 6.06557 20.7251 5.72675 21.0635C6.68606 22.2693 9.52413 23.4778 11.4946 23.5074C11.4946 23.2348 11.4946 22.9608 11.4946 22.6856C11.4946 22.4613 11.4893 22.2384 11.4959 22.0142C11.5065 21.6865 11.6965 21.4905 11.9875 21.4972C12.2639 21.5026 12.4499 21.6959 12.4539 22.0115C12.4618 22.503 12.4565 22.9944 12.4565 23.5168L12.4512 23.5154Z"
                    fill="#002E6D"
                  />
                  <path
                    d="M12.7422 9.81644V18.7983H11.4866V11.1861C11.0428 11.5137 10.6522 11.8038 10.2124 12.1287C10.2124 11.6628 10.207 11.2411 10.219 10.8208C10.2203 10.7658 10.3014 10.704 10.3572 10.661C10.696 10.4032 11.0361 10.1481 11.3816 9.89969C11.444 9.85403 11.5304 9.82181 11.6075 9.82047C11.9755 9.81241 12.3436 9.81644 12.7435 9.81644H12.7422Z"
                    fill="#002E6D"
                  />
                  <path
                    d="M18.0106 18.7364H17.151C17.151 18.6115 17.151 18.5027 17.151 18.394C17.151 17.5655 17.1536 16.7356 17.151 15.9071C17.151 15.7688 17.1443 15.6251 17.1111 15.4922C17.0619 15.2975 16.9145 15.2008 16.7205 15.1995C16.5291 15.1995 16.375 15.28 16.3325 15.4855C16.3059 15.6117 16.29 15.742 16.29 15.8709C16.286 16.7182 16.2886 17.5668 16.2886 18.4141V18.7337H15.4316V14.3884H16.2687C16.2793 14.4972 16.29 14.6046 16.2953 14.6543C16.5584 14.5482 16.8241 14.3951 17.1098 14.3361C17.4393 14.2676 17.6771 14.4985 17.9017 14.7443C18.1621 14.4864 18.4464 14.3025 18.8264 14.324C19.3194 14.3508 19.6622 14.6436 19.7273 15.1377C19.7525 15.3311 19.7525 15.5271 19.7538 15.7232C19.7565 16.6174 19.7538 17.5117 19.7538 18.406V18.7404H18.8862C18.8862 18.6303 18.8862 18.5309 18.8862 18.4329C18.8862 17.5668 18.8875 16.7007 18.8836 15.8346C18.8836 15.7151 18.8703 15.5916 18.8371 15.4774C18.7812 15.2827 18.6285 15.1968 18.4358 15.2008C18.2418 15.2048 18.0956 15.2975 18.0598 15.5029C18.0332 15.6574 18.0146 15.8158 18.0146 15.9729C18.0106 16.8847 18.0119 17.7978 18.0119 18.7377L18.0106 18.7364Z"
                    fill="#002E6D"
                  />
                  <path
                    d="M24.6512 18.7392H23.7823C23.7823 18.625 23.7823 18.5163 23.7823 18.4075C23.7823 17.5589 23.7823 16.7102 23.7823 15.8629C23.7823 15.7515 23.7823 15.6373 23.7597 15.5299C23.7158 15.3218 23.575 15.2076 23.3677 15.2009C23.1618 15.1942 23.0077 15.2869 22.9651 15.5044C22.9412 15.6306 22.9279 15.7622 22.9266 15.8911C22.924 16.7304 22.9253 17.5696 22.9253 18.4088V18.7324H22.0723V14.3899H22.908C22.9173 14.4973 22.9266 14.6061 22.9386 14.743C22.9944 14.6947 23.0395 14.6625 23.0767 14.6222C23.3624 14.312 23.7132 14.2569 24.0905 14.3872C24.4705 14.5188 24.6273 14.837 24.6406 15.2143C24.6619 15.7635 24.6512 16.3141 24.6526 16.8646C24.6526 17.4796 24.6526 18.0946 24.6526 18.7405L24.6512 18.7392Z"
                    fill="#002E6D"
                  />
                  <path d="M20.4805 14.3833H21.3136V18.7339H20.4805V14.3833Z" fill="#002E6D" />
                  <path d="M21.3162 12.6226V13.4712H20.4778V12.6226H21.3162Z" fill="#002E6D" />
                </g>
                <defs>
                  <clipPath id="clip0_3_2072">
                    <rect
                      width="24"
                      height="25"
                      fill="white"
                      transform="translate(0.652588 0.505371)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <p>
              Obtener tu presupuesto te llevará
              <span style="color: #FF595A; font-weight: 600;">menos de un minuto</span>. ¡Así de
              fácil!
            </p>
          </div>
        </div>
        <div class="container m-b-20">
          <h1 v-if="currentStep.title" class="title bluetext">{{ currentStep.title }}</h1>
          <h2 v-if="currentStep.subtitle" class="subtitle candidtext">
            {{ currentStep.subtitle }}
          </h2>
        </div>
        <div class="container m-b-20">
          <div v-for="(error, index) of errors" :key="index" class="notification is-warning">
            {{ error }}
          </div>
        </div>
        <funnel-paso-1
          v-if="currentStepIndex === 0"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-1>
        <funnel-paso-2
          v-if="currentStepIndex === 1"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-2>
        <funnel-paso-3
          v-if="currentStepIndex === 2"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-3>
        <funnel-paso-4
          v-if="currentStepIndex === 3"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-4>
        <funnel-paso-5
          v-if="currentStepIndex === 4"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-5>
        <funnel-paso-6
          v-if="currentStepIndex === 5"
          v-bind="{ currentStepIndex, currentStep, model, selectedDays }"
        ></funnel-paso-6>
      </div>
      <div class="hero-footer">
        <div class="container">
          <button type="submit" class="button cherry has-text-white is-medium m-b-10">
            <span class="icon" v-if="loading">
              <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                    <stop stop-color="#fff" stop-opacity="0" offset="0%" />
                    <stop stop-color="#fff" stop-opacity=".631" offset="63.146%" />
                    <stop stop-color="#fff" offset="100%" />
                  </linearGradient>
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(1 1)">
                    <path
                      d="M36 18c0-9.94-8.06-18-18-18"
                      id="Oval-2"
                      stroke="url(#a)"
                      stroke-width="2"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="0.9s"
                        repeatCount="indefinite"
                      />
                    </path>
                    <circle fill="#fff" cx="36" cy="18" r="1">
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="0.9s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </g>
                </g>
              </svg>
            </span>
            <span v-else>{{ currentStepIndex < 5 ? 'Siguiente' : 'Ver presupuesto' }}</span>
          </button>
          <p style="font-size: 10px; max-width: 400px" v-if="currentStepIndex === 5">
            <span style="text-decoration: underline">Protección de datos</span><br />El responsable
            del tratamiento es AUXISTENCIA S.L. La finalidad de la recogida de sus datos es para
            poder atender sus solicitudes de información, sin ceder sus datos a terceros. Tiene
            derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como
            se explica en la Política de Privacidad.
          </p>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from 'axios'
import Step1 from './components/Step1.vue'
import Step2 from './components/Step2.vue'
import Step3 from './components/Step3.vue'
import Step4 from './components/Step4.vue'
import Step5 from './components/Step5.vue'
import Step6 from './components/Step6.vue'

var getParams = function() {
  var params = {}
  var parser = document.createElement('a')
  parser.href = window.location.href
  var query = parser.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0]) {
      params[pair[0]] = decodeURIComponent(pair[1])
    }
  }
  return params
}

var getLastStepFromStorage = function() {
  var params = getParams.call(this)

  if (params.clearcookie) {
    this.$cookie.delete('funnel_last_step')
  }

  var storageData = this.$cookie.get('funnel_last_step')

  if (storageData) {
    return parseInt(storageData, 10)
  }

  return 0
}

var getModelFromStorage = function() {
  var params = getParams.call(this)

  if (params.clearcookie) {
    this.$cookie.delete('funnel_status')
  }

  var storageData = this.$cookie.get('funnel_status')

  if (storageData) {
    storageData = JSON.parse(storageData)
  } else {
    storageData = {}
  }

  return Object.assign(
    {},
    {
      referrer: params['referrer'] || null,
      employee: params['assigned'] || null,
      user_type: null, // 'self', 'relative', 'carer'
      duration_type: null, // 'temporal', 'indefinido'
      unknown_week_days: false, // true, false
      month_weeks: 4, // 1,2,3,4
      need_all_month: 'si', // true, false
      schedule_type: null, // 'unknown','regular','always','customized'
      schedule_single: [
        // [...]
        { start: null, end: null }
      ],
      schedule_multiple: [
        // [...]
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      customer: {
        name: null,
        email: null,
        phone: null,
        cp: null,
        terms: null
      },
      days: [
        { name: 'Lunes', short: 'Lun', enabled: false },
        { name: 'Martes', short: 'Mar', enabled: false },
        { name: 'Miércoles', short: 'Mie', enabled: false },
        { name: 'Jueves', short: 'Jue', enabled: false },
        { name: 'Viernes', short: 'Vie', enabled: false },
        { name: 'Sábado', short: 'Sab', enabled: false },
        { name: 'Domingo', short: 'Dom', enabled: false }
      ]
    },
    storageData
  )
}

export default {
  name: 'funnel',
  components: {
    'funnel-paso-1': Step1,
    'funnel-paso-2': Step2,
    'funnel-paso-3': Step3,
    'funnel-paso-4': Step4,
    'funnel-paso-5': Step5,
    'funnel-paso-6': Step6
  },
  data: function() {
    return {
      currentStepIndex: getLastStepFromStorage.call(this),
      loading: false,
      errors: [],
      steps: [
        {
          name: 'Paso 1',
          slug: 'paso-1',
          pageTitle: 'Paso 1 Presupuesto',
          pageDesc:
            'Paso 1 para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          title: '¿Quién necesita ayuda?',
          subtitle: 'Necesitaremos algunos detalles para poder calcular el mejor precio',
          validate: function() {
            // Si no ha seleccionado opción
            if (!this.model.user_type) {
              return {
                result: false,
                errors: ['Para continuar, seleccione una opción.']
              }
            }

            // Si está buscando trabajo
            if (this.model.user_type === 'carer') {
              window.location.replace('https://aiudo.es/ofertas-empleo-cuidadores')

              return {
                result: false,
                errors: []
              }
            }

            return {
              result: true,
              errors: []
            }
          }
        },
        {
          name: 'Paso 2',
          slug: 'paso-2',
          pageTitle: 'Paso 2 Presupuesto',
          pageDesc:
            'Paso 2 para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          title: '¿Cuánto tiempo necesitará el cuidado?',
          subtitle: 'No te preocupes si no lo sabes ahora, podrás cambiarlo más adelante',
          validate: function() {
            // Si no ha seleccionado opción
            if (!this.model.duration_type) {
              return {
                result: false,
                errors: ['Para continuar, seleccione una opción.']
              }
            }

            return {
              result: true,
              errors: []
            }
          }
        },
        {
          name: 'Paso 3',
          slug: 'paso-3',
          pageTitle: 'Paso 3 Presupuesto',
          pageDesc:
            'Paso 3 para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          title: '¿Qué días de la semana necesitará ayuda?',
          subtitle: 'Podrá seleccionar el horario a continuación',
          validate: function() {
            var enabled_days = this.model.days.filter(function(day) {
              return day.enabled
            })

            // Si no ha seleccionado opción
            if (!enabled_days.length && !this.model.unknown_week_days) {
              return {
                result: false,
                errors: [
                  'Para continuar, seleccione los días que necesitará servicio, o active la casilla de "Aún no lo tengo claro".'
                ]
              }
            }

            // Si no lo tiene claro, metemos un día vacío en el array, pa' que no pete.
            // TODO: Move me.
            if (!enabled_days.length) {
              this.$set(this.model.days[0], 'enabled', true)

              this.model.schedule_single.splice(0, 1, {
                start: null,
                end: null
              })

              this.model.schedule_multiple[0].push({
                start: null,
                end: null
              })
            }

            return {
              result: true,
              errors: []
            }
          }
        },
        {
          name: 'Paso 4',
          slug: 'paso-4',
          pageTitle: 'Paso 4 Presupuesto',
          pageDesc:
            'Paso 4 para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          title: '¿Necesitará ayuda todas las semanas?',
          subtitle: null,
          validate: function() {
            // Si no ha seleccionado opción
            if (this.model.need_all_month == 'no' && !this.model.month_weeks) {
              return {
                result: false,
                errors: ['Para continuar, seleccione una opción.']
              }
            }

            return {
              result: true,
              errors: []
            }
          }
        },
        {
          name: 'Paso 5',
          slug: 'paso-5',
          pageTitle: 'Paso 5 Presupuesto',
          pageDesc:
            'Paso 5 para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          title: '¿En qué horario necesitará la ayuda?',
          subtitle: 'Con esto ya terminamos y tendrás tu presupuesto al instante',
          validate: function() {
            // Si no ha seleccionado opción
            if (!this.model.schedule_type) {
              return {
                result: false,
                errors: ['Para continuar, seleccione una opción.']
              }
            }

            if (['always', 'unknown'].indexOf(this.model.schedule_type) !== -1) {
              return {
                result: true,
                errors: []
              }
            }

            var horasSemanales = 0

            if (this.model.schedule_type === 'regular') {
              horasSemanales = this.getSingleScheduleHours() * this.selectedDays.length
            }

            if (this.model.schedule_type === 'customized') {
              horasSemanales = this.getMultipleScheduleHours()
            }

            // Si el horario está vacío
            if (!horasSemanales) {
              return {
                result: false,
                errors: [
                  'Para calcular tu presupuesto, por favor, indícanos el horario en el que necesitas los cuidados.'
                ]
              }
            }

            // Si son menos de 3h
            if (horasSemanales < 3) {
              return {
                result: false,
                errors: ['El servicio mínimo es de, por lo menos, 3 horas semanales.']
              }
            }

            // Si son más de 120h (2 cuidadoras)
            if (horasSemanales > 120) {
              return {
                result: false,
                errors: [
                  'Para contratar un servicio de más de 120 horas semanales, por favor, ponte en contacto con nostros en el 900 805 012.'
                ]
              }
            }

            return {
              result: true,
              errors: []
            }
          }
        },
        {
          name: 'Paso 6',
          slug: 'paso-6',
          pageTitle: 'Paso Final Presupuesto',
          pageDesc:
            'Paso final para la configuración de presupuesto de una cuidadora de Aiudo. Completa este paso para recibir tu presupuesto a medida',
          validate: function() {
            // Si no ha metido algún dato
            if (
              !this.model.customer.name ||
              !this.model.customer.email ||
              !this.model.customer.phone ||
              !this.model.customer.cp
            ) {
              return {
                result: false,
                errors: ['Para ver el presupuesto, rellene sus datos.']
              }
            }

            return {
              result: true,
              errors: []
            }
          }
        }
      ],
      model: getModelFromStorage.call(this)
    }
  },
  created: function() {
    if (getParams().chatbot) {
      window.dataLayer.push({ event: 'chatbot-lead' })
    }
    window.addEventListener('popstate', this.onPopState)
  },
  mounted: function() {
    // Fire Google Optimize event.
    this.$nextTick(() => {
      window.dataLayer.push({
        event: 'optimize.activate'
      })
    })
  },
  methods: {
    onPopState: function(ev) {
      ev.preventDefault()

      // Fix URL.
      history.pushState({}, 'AiUDO - Los mayores cuidados', '/funnel/' + this.currentStep.slug)

      return window.Swal.fire({
        type: 'question',
        title: '¿Lo dejamos a medias?',
        text: 'Mejoramos cualquier presupuesto de la competencia.',
        confirmButtonText: 'OK, sigamos',
        cancelButtonText: 'Puedo esperar',
        showCancelButton: true,
        customClass: {
          confirmButton: 'button cherry has-text-white is-medium m-r-40',
          cancelButton: 'button is-small'
        },
        buttonsStyling: false
      }).then(function(result) {
        if (!result.value) {
          window.location.assign('https://aiudo.es')
        }
      })
    },
    getSingleScheduleHours: function() {
      return this.model.schedule_single.reduce(function(carry, slot) {
        if (slot.end) {
          return carry + (slot.end.hour - slot.start) + (slot.end.is_next_day ? 24 : 0)
        }

        return carry
      }, 0)
    },
    getMultipleScheduleHours: function() {
      return this.model.schedule_multiple.reduce(function(carry, day) {
        return (
          carry +
          day.reduce(function(carry, slot) {
            if (slot.end) {
              return carry + (slot.end.hour - slot.start) + (slot.end.is_next_day ? 24 : 0)
            }

            return carry
          }, 0)
        )
      }, 0)
    },
    clearStorage: function() {
      this.$cookie.delete('funnel_last_step')
      this.$cookie.delete('funnel_status')
    },
    saveLastRefPresu: function(ref_presup) {
      var ref = ref_presup.split('/')
      this.$cookie.set('ref_presup', ref[ref.length - 1], { expires: '6M' })
    },
    onSubmit: function(ev) {
      if (this.currentStepIndex + 1 < this.steps.length) {
        return this.nextStep()
      }

      if (this.loading) {
        return
      }

      var that = this

      this.loading = true

      // Adding gaconnector cookies values
      let gaconnector = {}
      for (let val of document.cookie.split(';').filter((word) => word.includes('gaconnector'))) {
        let cookie = val.trim().split('=')
        gaconnector[cookie[0]] = cookie[1]
      }
      let ad_personalization = localStorage.getItem('ad_personalization') === 'granted'
      let ad_user_data = localStorage.getItem('ad_user_data') === 'granted'

      var form = Object.assign({}, this.model, gaconnector, {
        // Adwords & Analytics IDs
        gclid:
          window.gAdwords && window.gAdwords.getGclid && window.gAdwords.getGclid()
            ? window.gAdwords.getGclid()['value']
            : null,
        gaid:
          window.ga && window.ga.getAll && window.ga.getAll().length
            ? window.ga.getAll()[0].get('clientId')
            : '',
        customer: {
          ...this.model.customer,
          ad_personalization: ad_personalization,
          ad_user_data: ad_user_data
        }
      })

      var clearStorage = this.clearStorage
      var savePresu = this.saveLastRefPresu

      axios
        .post('https://erp.aiudo.es/api/lead', form)
        .then(function(data) {
          // Clear the status, since this one is over
          clearStorage()

          if (data.data.ref_presup == 'nopresu') {
            /* window.gtag('event', 'page_view', {
                'send_to': 'UA-80431512-1',
                'page_title' : 'Presupuesto manual',
                'page_path': '/presupuesto/manual',
                'page_location': 'https://aiudo.es/presupuesto/manual'
              }); */

            // Send event to Google
            window.dataLayer.push({
              event: 'requested-quote-callback'
            })

            return window.Swal.fire({
              type: 'success',
              title: 'Propuesta en curso',
              text:
                'Como has indicado que aún no tienes claros algunos detalles, vamos a generar tu presupuesto de forma manual. Un asesor se pondrá en contacto contigo en breve.',
              confirmButtonText: 'Volver a la web',
              customClass: {
                confirmButton: 'button cherry has-text-white is-medium'
              },
              buttonsStyling: false
            }).then(function(result) {
              if (result.value) {
                window.location.assign('https://aiudo.es')
              }
            })
          }

          // Save generated presu
          savePresu(data.data.ref_presup)

          // Send event to Google
          window.dataLayer.push({
            event: 'generated-quote-callback'
          })

          that.loading = false

          window.Swal.fire({
            type: 'success',
            title: '¡Listo!',
            text: 'Te hemos enviado un correo electrónico con el enlace a tu presupuesto.',
            confirmButtonText: 'Ir al presupuesto'
          }).then(function(result) {
            if (result.value) {
              window.location.assign(data.data.ref_presup)
            }
          })
        })
        .catch(function(err) {
          return window.Swal.fire({
            type: 'success',
            title: 'Propuesta en curso',
            text:
              'Como has indicado que aún no tienes claros algunos detalles, vamos a generar tu presupuesto de forma manual. Un asesor se pondrá en contacto contigo en breve.',
            confirmButtonText: 'Volver a la web',
            customClass: {
              confirmButton: 'button cherry has-text-white is-medium'
            },
            buttonsStyling: false
          }).then(function(result) {
            that.loading = false
            window.location.assign('https://aiudo.es')
          })
        })
    },
    nextStep: function() {
      // Bounds.
      if (this.currentStepIndex + 1 === this.steps.length) {
        return
      }

      // Validate.
      var isValid = this.currentStep.validate.call(this)

      if (!isValid.result) {
        this.errors = isValid.errors

        return
      }

      // Empty errors.
      this.errors.splice(0, this.errors.length)

      // Actually go to next step.
      this.currentStepIndex += 1

      // Fire Google Optimize event.
      this.$nextTick(() => {
        window.dataLayer.push({
          event: 'optimize.activate'
        })
      })
    },
    previousStep: function() {
      // Bounds.
      if (this.currentStepIndex <= 0) {
        return
      }

      // Empty errors.
      this.errors.splice(0, this.errors.length)

      // Actually go to previous step.
      this.currentStepIndex -= 1

      // Fire Google Optimize event.
      this.$nextTick(() => {
        window.dataLayer.push({
          event: 'optimize.activate'
        })
      })
    }
  },
  computed: {
    currentStep: function() {
      return this.steps[this.currentStepIndex]
    },
    selectedDays: function() {
      return this.model.days.filter(function(el) {
        return el.enabled
      })
    }
  },
  watch: {
    currentStepIndex: {
      immediate: true,
      handler() {
        const descEl = document.querySelector('head meta[name="description"]')
        descEl.setAttribute('content', this.currentStep.pageDesc || 'Calcula tu presupuesto')
        document.title = this.currentStep.pageTitle || 'Calcula tu presupuesto'
      }
    }
  }
}
</script>

<style>
.bubble-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.bubble-message {
  display: inline-flex;
  width: auto;
  background-color: white;
  padding: 1rem 2rem;
  box-shadow: 50px 5px 100px 10px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
  font-size: 16px;
  margin-bottom: 2rem;
  position: relative;
  max-width: 80%;
  flex-direction: row;
  align-items: center;
}

.bubble-message::before {
  content: '';
  position: absolute;
  right: -0.6rem;
  bottom: 0.2rem;
  width: 1.5rem;
  height: 0.9rem;
  border-radius: 50px 0px 80px 10px;
  background: white;
  transform: rotate(39deg);
}

.bubble-message p {
  text-align: left;
  margin-left: 1rem;
  color: #002e6d;
  max-width: 100%;
}

.bubble-message span {
  color: #ff595a;
  font-weight: 600;
}
@media (max-width: 768px) {
  .bubble-container {
    justify-content: center;
    margin-right: 0;
    width: 100%;
  }
  
  .bubble-message {
    display: flex;
    padding: 0.5rem;
    width: 100%;
    max-width: none;
  }

  .bubble-message .icon {
    margin-right: 0.5rem;
  }
}
</style>
